import { render, staticRenderFns } from "./news-list.vue?vue&type=template&id=03d7d044&scoped=true"
import script from "./news-list.vue?vue&type=script&lang=js"
export * from "./news-list.vue?vue&type=script&lang=js"
import style0 from "./news-list.vue?vue&type=style&index=0&id=03d7d044&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d7d044",
  null
  
)

export default component.exports